import type { CellData as RootCellData } from '../types';

import type { getCellTemplate } from './utils';

export const kind = 'shares-cell' as const;

export interface SharesCellData
  extends RootCellData<typeof kind, number | null> {
  error: string | null;
}

export type SharesCell = ReturnType<typeof getCellTemplate>;
